import React, { Component } from "react";
import { Table } from "semantic-ui-react";

class ItemEstadoVenta extends Component {
  state = {};
  handleClick = () => this.props.handleClick(this.props.datos);
  render() {
    return (
      <Table.Row style={{ cursor: "pointer" }}>
        <Table.Cell content={this.props.datos} onClick={this.handleClick} />
      </Table.Row>
    );
  }
}

export default ItemEstadoVenta;



// WEBPACK FOOTER //
// ./src/pages/ventas/ventas/tablaColegios/filaColegios/estadoVenta/ItemEstadoVenta.jsx